import { HttpClient } from '@angular/common/http'
import { Inject, Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { Market } from '../models/market'
import { AppConfig, APP_CONFIG } from 'src/app.config';

@Injectable({
  providedIn: 'root',
})
export class MarketService {
  public API_URL: string;

  constructor(
    @Inject(APP_CONFIG) appConfig: AppConfig,
    private http: HttpClient
  ) {
    this.API_URL = appConfig.urlApi;
  }

  getAllMarket(): Observable<any> {
    const url = this.API_URL + '/Markets';
    return this.http.get<any>(url);
  }

  getMarketById(idMarket: number): Observable<any> {
    const url = this.API_URL + '/Markets/' + idMarket;
    return this.http.get<any>(url);
  }

  postMarket(market: Market): Observable<any> {
    const url = this.API_URL + '/Markets';
    return this.http.post<any>(url, market);
  }

  updateMarket(market: Market): Observable<any> {
    const url = this.API_URL + '/Markets/' + market.id;
    return this.http.patch<any>(url, market);
  }

  deleteMarket(idMarket: number): Observable<any> {
    const url = this.API_URL + '/Markets/' + idMarket;
    return this.http.delete<any>(url);
  }

  changeOrderUp(idMarket: number): Observable<any> {
    const url = this.API_URL + '/Markets/up/' + idMarket;
    return this.http.patch<any>(url, {});
  }

  changeOrderDown(idMarket: number): Observable<any> {
    const url = this.API_URL + '/Markets/down/' + idMarket;
    return this.http.patch<any>(url, {});
  }
}
